var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icoButton",attrs:{"data-icoTarget":"left"},on:{"click":function($event){return _vm.panel.$emit('update:show', false)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }